module.exports = __webpack_public_path__ + "img/employmentPolicies.4bc768ff.svg";